import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Deprecated: Plus is surfaced via the UpgradeModal / Settings. This route is
 * kept only so old /join/upgrade-to-plus links don't 404 — it immediately
 * redirects to Settings.
 */
const UpgradeToPlus = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings', { replace: true });
  }, [navigate]);

  return null;
};

export default UpgradeToPlus;
